import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import useHandleGroupSearch from '../../pages/deviceManagement/useHandleGroupSearch';
import { userList } from '../../pages/users/listUserSlice';
import { updateUser } from "./updateUserSlice";
import { useSpinner } from '../../customHooks';
import { userRoles } from '../../pages/users/util';
import { selector as updateUserApi, actions as modalActions } from './updateUserSlice';
import { getCookie, isSuccessResponse } from '../../common/utils';
import { IGroupAlerts } from '../../common/types/alertsTypes';
import { EditUserProps, IUserState } from '../../common/types/userTypes';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import useNotification from '../notification/useNotification';

export const useUpdateUserModal = () => {
  const updateUserResponse: IUserState = useSelector(updateUserApi);
  const userData: EditUserProps = useSelector(updateUserApi).userData;
  const { isActive: isModalActive } = useSelector(updateUserApi);
  const nameDefaultValue: string = userData ? userData.userName : "";
  const phoneNumberDefaultValue: string = userData ? userData.phoneNo : "";
  const roleDefaultValue: string = userData ? userRoles.find(userRole => userRole.displayName === userData.roleId).id : "";
  const emailDefaultValue: string = userData ? userData.email : "";
  const parentOrgDefaultVale: string = userData ? userData.groupName : "";
  const idDefaultValue: string = userData ? userData.Id : "";
  const [email, setEmail] = useState<string>(emailDefaultValue);
  const [Id, setId] = useState<string>(idDefaultValue);
  const [name, setName] = useState<string>(nameDefaultValue);
  const [phoneNumber, setPhoneNumber] = useState<string>(phoneNumberDefaultValue);
  const [role, setRole] = useState<string>(roleDefaultValue);
  const [parentOrg, setParentOrg] = useState<string>(parentOrgDefaultVale);

  const [isEmptyGroupShown, setIsEmptyGroupShown] = useState<boolean>(true);
  const [searchTerm, setSearchTerm] = useState<string>('');

  const dispatch: ThunkDispatch<IUserState, undefined, Action> = useDispatch();
  const checkedBox: string[] = userData ? [userData.groupName] : [];
  const isCurrentUser: boolean = userData ? userData.email === decodeURIComponent(getCookie("email")) : false;
  const handleShow = (): void => {
    setParentOrg(parentOrgDefaultVale);
    setName(nameDefaultValue);
    setPhoneNumber(phoneNumberDefaultValue);
    setGroupSearchQuery('');
    setRole(roleDefaultValue);
    setEmail(emailDefaultValue);
    setId(idDefaultValue);
  }

  useSpinner(updateUserResponse.status);

  const handleDataFromTreeView = (selectedGroup: IGroupAlerts): void => {
    const data: IGroupAlerts = selectedGroup;
    const orgData = data?.id ? data.id : "";
    setParentOrg(orgData);
  };

  useEffect(() => {
    if (isModalActive) {
      handleShow();
    }
  }, [isModalActive])

  useEffect(() => {
    setParentOrg(parentOrgDefaultVale)
  }, [parentOrgDefaultVale])


  const {
    handleGroupInputChange,
    groupSearchQuery,
    nodesToDisplay,
    setGroupSearchQuery
  } = useHandleGroupSearch({ isEditable: false });


  const handleClose = () => {
    dispatch(modalActions.hideModal());
  };


  const handleOnSubmit = (e) => {
    e.preventDefault();
    const orgId = getCookie("organizationId");
    const body = {
      name,
      phoneNo: phoneNumber,
      role,
      groupId: parentOrg,
      organizationId: orgId,
    }
    const payload = {
      userId: Id,
      body,
    }
    dispatchUpdateUser(updateUser, payload);
    handleClose();
  }

  const { showSuccessNotification, showWarningNotification } = useNotification();


  const dispatchUpdateUser = (
    action,
    payload,
  ) => {
    try {
      dispatch(action(payload)).then((response) => {
        if(isSuccessResponse(response.payload)){
          showSuccessNotification(response.payload.message);
          dispatch(userList());
        }
        else {
          showWarningNotification(response.payload.response.data.message);
        }
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };


  return {
    handleGroupInputChange,
    groupSearchQuery,
    nodesToDisplay,
    handleDataFromTreeView,
    setIsEmptyGroupShown,
    setSearchTerm,
    setEmail,
    email,
    name,
    setName,
    phoneNumber,
    setPhoneNumber,
    role,
    setRole,
    parentOrg,
    handleShow,
    handleClose,
    handleOnSubmit,
    isModalActive,
    checkedBox,
    isCurrentUser
  };
}